import React from 'react'
import Button from 'react-bootstrap/Button'
import { PulseLoader } from 'react-spinners'

const LoaderButton = (props) => {

  const getTextWidth = (text, font) => {
    const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"))
    const context = canvas.getContext("2d")
    context.font = font
    const metrics = context.measureText(text)
    return metrics.width
  }

  const textWidth = Math.round(getTextWidth(props.buttonText, '12pt sans-serif'))

  return (
    <Button
      onClick={props.onClick}
      style={{width: textWidth + 30, minWidth: '120px'}}
      variant={props.buttonVariant}
    >
      {props.loading ?
        <PulseLoader
          css={props.loaderStyle}
          color={props.loaderColor}
        />
        :
        props.buttonText
      }
    </Button>
  )
}

LoaderButton.defaultProps = {
  loaderStyle: 'display: block; margin: 0 auto;',
  loaderColor: 'white',
  buttonVariant: 'primary',
}

export default LoaderButton
